export default __webpack_public_path__ + "static/red_frog_mobile-c5fb8f61153c693902928bf37cb8a0ff.png";